import CT from '@marketplace-ai/tags';
import { useSelector } from '@xstate/react';
import { BasicGrid } from '~/components/agGrid/Grid';
import { PROVIDER_PAGE_KEYS } from '~/routing/routes';
import { UserContext } from '../../../app';
import { EmptyState, FormDialog, TableCard } from '../../../components';
import { AOIForm } from './AOIForm';
import { CreateAoiColumns } from './constants';
import { CreateAOIFormValues } from './types';

const TAGS = CT.aoi;

const AOINoRowsOverlay = () => (
  <EmptyState
    pageKey={PROVIDER_PAGE_KEYS.aoi}
    title="No areas of interest yet"
    cyTag={TAGS.table.emptyState}
  />
);

export const AOIDetails = () => {
  const { vaultRef } = useSelector(UserContext.useActorRef(), (state) => {
    return state.context;
  });

  if (!vaultRef) {
    return null;
  }
  const { aoiRef } = useSelector(vaultRef, (state) => {
    return state.context;
  });
  const { aois, modal, loading, AOIOptions, AOISpecialtyOptions, formValues, submitError } =
    useSelector(aoiRef, (state) => state.context);

  const addAOI = (formData: CreateAOIFormValues) => {
    aoiRef.send({ type: 'ON_SUBMIT', values: formData });
  };

  const handleDelete = (id: number) => {
    aoiRef.send({ type: 'ON_SEND_DELETE_CONFIRMATION', payload: { id } });
  };

  const handleOpen = () => {
    aoiRef.send({ type: 'ON_OPEN' });
  };

  const handleClose = () => {
    aoiRef.send({ type: 'ON_CLOSE' });
  };

  const getSpecOptions = () => {
    aoiRef.send({ type: 'ON_GET_SPEC_OPTIONS' });
  };

  const setSpecId = (value: string) => {
    aoiRef.send({ type: 'ON_SET_SPECIALTIES_ID', payload: { specialtiesId: value } });
  };
  return (
    <>
      <TableCard
        mobilePageHeader
        title="Areas of Interest"
        addLabel="Add New Area of Interest"
        onAddClick={handleOpen}
        addBtnTag={TAGS.addBtn}
        layoutTag={TAGS.layout}
      >
        <BasicGrid
          data={aois}
          loading={loading}
          colDefs={CreateAoiColumns({ handleDelete })}
          pagination={true}
          cyTag={TAGS.grid}
          noRowsOverlayComponent={AOINoRowsOverlay}
        />
      </TableCard>
      <FormDialog
        creating={modal}
        onClose={handleClose}
        title={'Add New Area of Interest'}
        editing={false}
      >
        <AOIForm
          AOIOptions={AOIOptions}
          AOISpecialtyOptions={AOISpecialtyOptions}
          formValues={formValues}
          add={addAOI}
          getSpecOptions={getSpecOptions}
          handleClose={handleClose}
          setSpecId={setSpecId}
          submitError={submitError}
        />
      </FormDialog>
    </>
  );
};
